module.exports = __webpack_public_path__ + "static/media/Lus.055b4a23.PNG";